export default __webpack_public_path__ + "static/media/first.3b708f3b.png";